module.exports = __webpack_public_path__ + "img/fa-solid-900.37bc7099.svg";